import { Box, Button, Divider, Flex, Text } from '@podiumhq/design-system';
import { buttonGhostLinkStyles } from 'styles';
import React from 'react';

export const ConfirmDetailsSectionWrapper = ({
  children,
  displayDivider,
  openModal,
  title,
  ...boxProps
}) => {
  const buttonAsLinkStyles = {
    ...buttonGhostLinkStyles,
    color: 'blue.base',
    fontWeight: 'normal',
    size: 'sm',
    _hover: { ...buttonGhostLinkStyles._hover, textDecoration: 'underline' },
    alignItems: 'start',
  };
  const dividerStyles = { margin: '24px 0' };

  return (
    <>
      <Box {...boxProps}>
        <Text fontSize="lg" fontWeight="medium" mb="12px" mt="0">
          {title}
        </Text>

        <Flex justify="space-between">
          <Box>{children}</Box>

          {openModal && (
            <Button {...buttonAsLinkStyles} onClick={openModal}>
              Change
            </Button>
          )}
        </Flex>
      </Box>

      {displayDivider && <Divider {...dividerStyles} />}
    </>
  );
};
